export type BudgetType = "PFR" | "SUBSCRIPTION" | "FLAT_FEE" | "MEDIA_SPEND";

export type ReplenishFrequency =
  | "DAILY"
  | "WEEKLY"
  | "MONTHLY"
  | "QUARTERLY"
  | "YEARLY";

export class Budget {
  id: number;
  contract_id: number;
  budget_type: BudgetType;
  starting_balance: number;
  replenish_amount: number | null;
  replenish_frequency: ReplenishFrequency | null;
  start_date: string;
  end_date: string | null;
  is_active: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.contract_id = data.contract_id;
    this.budget_type = data.budget_type;
    this.starting_balance = Number(data.starting_balance ?? 0);
    this.replenish_amount =
      data.replenish_amount != null ? Number(data.replenish_amount) : null;
    this.replenish_frequency = data.replenish_frequency ?? null;
    this.start_date = data.start_date;
    this.end_date = data.end_date ?? null;
    this.is_active = data.is_active ?? true;
  }
}
